import { _ReactPixi, Container, Graphics } from '@pixi/react'
import { ReactElement, useCallback } from 'react'
import { Draw } from '@slot-nx/core'

export const GrayBackground = (props: {
  children?: ReactElement
  name?: string
  isChangePose?: boolean
  width: number
  height: number
}) => {
  const draw = useCallback<Draw>((graphics) => {
    graphics.clear()
    graphics.beginFill('black', props.isChangePose ? 1 : 0.8)
    graphics.drawRect(0, -220, props.width, props.height + 220)
    graphics.endFill()
  }, [])

  return (
    <Container
      name={props.name ? props.name : 'GrayBackground'}
      x={0}
      y={0}
      width={props.width}
      height={props.height}
    >
      <Graphics
        width={props.width}
        height={props.height}
        draw={draw}
        eventMode="static"
      />
      {props.children}
    </Container>
  )
}
